import { AuthenticatedImagePipe } from './authenticated-image.pipe';
import { SafePipe } from './safe.pipe';
import { SecurePipe } from './secure.pipe';

import { NgModule } from '@angular/core';

@NgModule({
    declarations: [
        SecurePipe,
        SafePipe,
        AuthenticatedImagePipe
    ],
    imports: [],
    exports: [
        SecurePipe,
        SafePipe,
        AuthenticatedImagePipe
    ]
})
export class PipesModule {}